// Module
var code = "<dropdown-field :value.sync=\"localValue\" :options=\"options\" :validation=\"validation\" :disabled=\"disabled\" :required=\"required\" :null-is-dirty=\"nullIsDirty\" :label=\"label\" :hide-label=\"hideLabel\"> </dropdown-field> ";
// Exports
export default code;